module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ca48ed4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home-template/refresh.vue
// module id = 1477
// module chunks = 7